<template>
    <v-app>
        <header-bar v-model="drawer" />
        <v-main>
            <v-container class="fill-height grid-list-md text-center">
                <slot />
            </v-container>
        </v-main>
        <footer-bar />
        <navigation-drawer-mobile v-if="isMobile" v-model="drawer" />
    </v-app>
</template>

<script lang="ts">
    import {Component} from 'vue-facing-decorator'
    import HeaderBar from '~src/components/headerBar.src'
    import FooterBar from '~src/components/footerBar.src'
    import {BaseLayout} from '@/components/BaseLayout.vue'
    import NavigationDrawerMobile from '~src/components/snippets/navigationDrawerMobile.src'

    @Component({
        components: {
            HeaderBar,
            FooterBar,
            NavigationDrawerMobile,
        },
    })
    export class CenteredLayout extends BaseLayout {
        get isMobile() {
            return this.$breakpoint.smAndDown
        }
    }

    export default CenteredLayout
</script>
